import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliatesTableDataResponseRecord } from '../types';
import { AFFILIATES_APPROVED_PERMISSIONS, AFFILIATES_LIST_API_URL, AFFILIATES_LIST_QUERY_KEY } from '../constants';

export default function useAffiliatesListQuery(tableState: Ref<ITableState>, enabled = true): IContextQueryResult<
  ITableDataResponse<IAffiliatesTableDataResponseRecord>,
  Error
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliatesTableDataResponseRecord>>({
    queryKey: [AFFILIATES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliatesTableDataResponseRecord>>(
      AFFILIATES_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
      },
    ),
    placeholderData: keepPreviousData,
    enabled,
  });
}
